export default function Divider() {
  return <div style={divider}></div>;
}

const divider = {
  height: 1,
  backgroundColor: "#E8E8E8",
  width: "100%",
};
